import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";

export default function sendTyping(typing: boolean): ChatServerAsyncActionType {
    return chatServer => () => {
        chatServer.sendTyping(typing);
    };
}